<template>
  <div class="page">

    <div class="container">

      <router-link
        to="/kpp"
        class="inc"
      >
        <svg width="202" height="24" viewBox="0 0 202 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="24" height="24" rx="12" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M18 12.0033C18 11.4511 17.5523 11.0033 17 11.0033L9.20255 11.0033L11.2528 8.65818C11.6164 8.24239 11.574 7.61065 11.1582 7.24714C10.7424 6.88363 10.1107 6.92601 9.74715 7.34179L6.24715 11.3451C5.91741 11.7223 5.91764 12.2853 6.2477 12.6622L9.7477 16.6588C10.1116 17.0743 10.7433 17.1161 11.1588 16.7523C11.5743 16.3884 11.6162 15.7567 11.2523 15.3412L9.20498 13.0033L17 13.0033C17.5523 13.0033 18 12.5556 18 12.0033Z" fill="#A0A0A0"/>
          <path d="M37.8 18V5.4H39.78V11.52L45.45 5.4H47.97L43.11 10.62L48.33 18H45.9L41.76 12.06L39.78 14.22V18H37.8ZM50.3023 18V5.4H60.4723V18H58.4923V7.29H52.2823V18H50.3023ZM64.2459 18V5.4H74.4159V18H72.4359V7.29H66.2259V18H64.2459Z" fill="#A0A0A0"/>
          <rect x="89" y="21" width="18" height="2" rx="1" transform="rotate(-90 89 21)" fill="#A0A0A0"/>
          <path d="M104.8 18V5.4H106.78V14.67L113.71 5.4H115.51V18H113.53V8.73L106.6 18H104.8ZM118.749 18V9.36H120.549V12.78H124.779V9.36H126.579V18H124.779V14.4H120.549V18H118.749ZM129.282 18V9.36H131.082V16.29H135.132V9.36H136.932V16.29H138.192V20.16H136.392V18H129.282ZM139.991 18V9.36H141.791V15.12L146.291 9.36H147.911V18H146.111V12.24L141.611 18H139.991ZM149.353 20.16V16.29H149.983C150.235 16.026 150.475 15.672 150.703 15.228C151.183 14.268 151.423 13.152 151.423 11.88V9.36H157.723V16.29H158.983V20.16H157.183V18H151.153V20.16H149.353ZM151.873 16.29H155.923V11.07H153.223V11.88C153.223 13.152 152.995 14.268 152.539 15.228C152.347 15.624 152.125 15.978 151.873 16.29ZM167.347 15.3L168.427 16.56C168.199 16.86 167.899 17.13 167.527 17.37C166.711 17.91 165.781 18.18 164.737 18.18C163.477 18.18 162.409 17.748 161.533 16.884C160.669 16.008 160.237 14.94 160.237 13.68C160.237 12.42 160.663 11.358 161.515 10.494C162.379 9.618 163.423 9.18 164.647 9.18C165.871 9.18 166.879 9.582 167.671 10.386C168.475 11.178 168.877 12.186 168.877 13.41C168.877 13.518 168.859 13.734 168.823 14.058L168.787 14.31H162.127C162.235 14.922 162.535 15.438 163.027 15.858C163.519 16.266 164.119 16.47 164.827 16.47C165.475 16.47 166.087 16.278 166.663 15.894C166.927 15.726 167.155 15.528 167.347 15.3ZM162.127 12.78H166.987C166.843 12.168 166.573 11.688 166.177 11.34C165.781 10.98 165.271 10.8 164.647 10.8C163.375 10.8 162.535 11.46 162.127 12.78ZM171.029 18V9.36H172.829V12.78H177.059V9.36H178.859V18H177.059V14.4H172.829V18H171.029ZM183.633 18V11.07H180.663V9.36H188.403V11.07H185.433V18H183.633ZM198.388 18V9.36H200.188V18H198.388ZM191.998 16.38H193.798C194.29 16.38 194.668 16.26 194.932 16.02C195.196 15.78 195.328 15.45 195.328 15.03C195.328 14.61 195.196 14.28 194.932 14.04C194.668 13.8 194.29 13.68 193.798 13.68H191.998V16.38ZM190.198 18V9.36H191.998V12.06H193.798C194.818 12.06 195.628 12.336 196.228 12.888C196.828 13.44 197.128 14.154 197.128 15.03C197.128 15.906 196.828 16.62 196.228 17.172C195.628 17.724 194.818 18 193.798 18H190.198Z" fill="#A0A0A0"/>
        </svg>
      </router-link>
    </div>


    <q-scroll-up-button :quantityPaginationPage="quantityPaginationPage" />

    <q-acts-preloader v-if="preloader" />

    <q-empty-content v-if="notFoundMessage" :message="notFoundMessage" />

    <transition name="default">
      <div v-if="!preloader" class="container">
        <q-incident-item
          v-for="inc in acts"
          :key="inc.id"
          :data="inc"
        />
      </div>
    </transition>


    <v-pagination
      v-if="quantityPaginationPage > 1"
      v-model="currentPaginationPage"
      :pages="quantityPaginationPage"
      :range-size="1"
      @update:modelValue="updateHandler"
    />

    <q-bottom-panel>
      <QActsFilters
        @setCarNumber="setCarNumber"
        @setTransporter="setTransporter"
        @setClient="setClient"
        @setPolygon="setPolygon"
        @setSortType="setSortType"
        @setFilteredDate="setFilteredDate"
        @setTemporaryActNumber="setTemporaryActNumber($event)"
        @downloadExcel="downloadExcel"
        :tonnage="tonnage"
        :weights="weights"
        :passes="acts.length"
        :numDispute="numDispute"
        :tonnageDispute="tonnageDispute"
        :wasteCategory="switcherSelectItems.length ? currentWaste.id : ''"
        kpp
        incidents
      />
    </q-bottom-panel>
  </div>
</template>

<script setup>
import { defineComponent, onMounted, ref, watch, computed } from 'vue'
import moment from 'moment'
import store from '@/store'
import useRouterGuard from '@/composables/useRouterGuard'
import useApi from '@/composables/useApi'
import QActsItem from '@/views/acts/QActsItem.vue'
import QActsFilters from '@/views/acts/QActsFilters.vue'
import QActsPreloader from '@/views/acts/QActsPreloader.vue'
import QBottomPanel from '@/components/common/QBottomPanel.vue'
import QEmptyContent from '@/components/common/QEmptyContent.vue'
import VPagination from '@hennge/vue3-pagination'
import QScrollUpButton from '@/components/common/QScrollUpButton.vue'
import { notify } from '@kyvg/vue3-notification'
import QWasteSwitcher from '@/components/ui/QWasteSwitcher.vue'
import { useRouter } from 'vue-router'

import QIncidentItem from './QIncidentItem.vue'


const router = useRouter()

const preloader = ref(false)
const acts = ref([])
const tonnage = ref(0)
const weights = ref(0)
const numDispute = ref(0)
const tonnageDispute = ref(0)
const notFoundMessage = ref('')

const isShowIncidents = ref(false)


onMounted(async () => {
  if (store.state.user.role === 4) {
    router.push('/counterparties')
  }

  date.value = [moment().utc(moment()._d), moment().utc(moment()._d)]
  await useRouterGuard()
  await getSwitchers()
  preloader.value = true
})

const carNumber = ref('')
const transporter = ref('')
const client = ref('')
const polygon = ref('')
const sortType = ref('date_desc')
const date = ref(['', ''])

const isDirtyFields = ref(false)

const quantityPaginationPage = ref(1)
const currentPaginationPage = ref(1)

const temporaryActNumber = ref(null)

const currentWasteType = ref('')
const currentWasteCategory = ref('')

watch(
  () => quantityPaginationPage.value,
  (val) => currentPaginationPage.value = 1
)

const getActs = async (dispute = false) => {
  store.dispatch('setGlobalPreloader', true)
  acts.value = []
  preloader.value = true
  notFoundMessage.value = ''

  const actsData = await useApi('post', 'incidents/by_filters', {
    current_page: isDirtyFields.value ? 1 : currentPaginationPage.value,
    date_start: date.value[0] ? date.value[0] : '',
    date_stop: date.value[1] ? date.value[1] : '',
  })

  if (actsData.status === 'error') {
    notFoundMessage.value = actsData.error.message
  }

  acts.value = actsData.data.incidents
  quantityPaginationPage.value = actsData.pages

  preloader.value = false

  isDirtyFields.value = false
  store.dispatch('setGlobalPreloader', false)
}

const setTemporaryActNumber = (e) => {
  temporaryActNumber.value = e
  getActs()
}

const switcherSelectItems = ref([])

const currentWaste = ref({
  id: 'tko',
  label: 'ТКО'
})
watch(
  () => currentWaste.value,
  (val) => getActs()
)

const getSwitchers = async () => {
  const res = await useApi('get', 'waste/get_info')

  if (res.waste.length) {
    switcherSelectItems.value = res.waste
    currentWaste.value = switcherSelectItems.value[0]
  }
  getActs()
}

const updateHandler = (e) => {
  currentPaginationPage.value = e
  getActs()
}

const setSortType = e => {
  isDirtyFields.value = true
  sortType.value = e.id
  getActs()
}

const setPolygon = e => {
  polygon.value = e
  isDirtyFields.value = true
  getActs()
}

const setTransporter = e => {
  transporter.value = e
  isDirtyFields.value = true
  getActs()
}

const setClient = e => {
  client.value = e
  isDirtyFields.value = true
  getActs()
}

const setCarNumber = e => {
  carNumber.value = e
  isDirtyFields.value = true
  getActs()
}

const setFilteredDate = e => {
  isDirtyFields.value = true
  date.value = [moment(e[0]).utc(e[0]), moment(e[1]).utc(e[1])]
  getActs()
}

const updateActStatus = id => {
  acts.value[acts.value.findIndex(item => item.id === id)].dispute = !acts.value[acts.value.findIndex(item => item.id === id)].dispute
  setTimeout(() => getActs(), 1000)
}

const downloadExcel = async () => {
  store.dispatch('setGlobalPreloader', true)
  const req = await useApi('post', 'acts/get_excel', {
    car_number: carNumber.value,
    date_start: date.value[0] ? date.value[0] : '',
    date_stop: date.value[1] ? date.value[1] : '',
    platform_name: polygon.value,
    transporter_name: transporter.value,
    waste_category: currentWasteCategory.value,
    waste_type: currentWasteType.value,
    client: client.value,
  })

  if (req.docs) {
    window.open(req.docs, '_self');
  }
  store.dispatch('setGlobalPreloader', false)
}


const setSwitcherValue = item => {
  if (item.category_id) {
    currentWasteType.value = item.id
    currentWasteCategory.value = item.category_id
  } else {
    currentWasteType.value = ''
    currentWasteCategory.value = item.id
  }
}
</script>

<style scoped lang="scss">
.page {
  padding-bottom: 150px;
}

.q-acts-switcher {
  position: relative;
  width: 200px;
}

.incident-btn{
  padding: 11px 20px;
  display: flex;
  gap: 10px;
  background: #E0E0E0;
  width: fit-content;
  border-radius: 14px;
  cursor: pointer;
}

.incident-btn-back{
  cursor: pointer;
}

.inc{
  display: block;
  margin-bottom: 15px;
}
</style>
